/**
 * OGoldTable
 * json data table component for gold rates
 * api response
 * {
 *    "carat14": 300.00,
 *    "carat18": 600.00,
 *    "carat21": 540.00,
 *    "carat24": 450.00,
 *    "lastUpdated": "2024-06-19T10:30:00Z"
 * }
 */

import React from "react";
import "./common-tabel.m.css";

import { formatRate } from "../util";
const CTA = "https://ogold.onelink.me/1ztX/48fnnhkp";

const OGoldTable = ({ data }) => {
  console.log("OGoldTable data:", data);
  if (!data) return null;

  return (
    <div styleName="table-container" style={{ marginTop: "var(--spacing-l)", marginBottom: "var(--spacing-l)" }}>
      <div styleName="title" style={{ display: "flex" }}>
        Gold rates today by OGold{" "}
        <span
          style={{
            backgroundColor: "#a90000",
            borderRadius: "3px",
            fontWeight: "500",
            color: "var(--white)",
            fontSize: "var(--font-xs)",
            alignItems: "center",
            lineHeight: "14px",
            padding: "3px 4px 2px",
            marginLeft: "10px",
          }}
        >
          LIVE
        </span>
      </div>
      <div
        style={{
          paddingLeft: "60px",
          backgroundImage: "url('https://images.assettype.com/gulfnews-uat/2026-04-09/m6m2afds/Layer1.svg')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "left center",
          backgroundColor: "#000",
          position: "relative",
        }}
      >
        <a
          href={CTA}
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            width: "60px",
            height: "100%",
            zIndex: 1,
          }}
          target="_blank"
          title="OGold Rates"
          rel="noopener noreferrer"
        ></a>
        <table styleName="rate-exchange-table gold-table ogold-table">
          <thead>
            <tr>
              <th
                style={{
                  fontWeight: "600",
                  backgroundColor: "#FFF6D2",
                  color: "#0C1215",
                  borderColor: "#FFF",
                  borderTop: "none",
                  borderLeft: "none",
                }}
              >
                <span styleName="label-desktop">24 Carat</span>
                <span styleName="label-mobile">24K</span>
              </th>
              <th
                style={{
                  fontWeight: "600",
                  backgroundColor: "#E1BF69",
                  color: "#0C1215",
                  borderColor: "#FFF",
                  borderTop: "none",
                }}
              >
                <span styleName="label-desktop">22 Carat</span>
                <span styleName="label-mobile">22K</span>
              </th>
              <th
                style={{
                  fontWeight: "600",
                  backgroundColor: "#FFF6D2",
                  color: "#0C1215",
                  borderColor: "#FFF",
                  borderTop: "none",
                }}
              >
                <span styleName="label-desktop">18 Carat</span>
                <span styleName="label-mobile">18K</span>
              </th>
              <th
                style={{
                  fontWeight: "600",
                  backgroundColor: "#E1BF69",
                  color: "#0C1215",
                  borderColor: "#FFF",
                  borderTop: "none",
                  borderRight: "none",
                }}
              >
                <span styleName="label-desktop">14 Carat</span>
                <span styleName="label-mobile">14K</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                style={{
                  backgroundColor: "#FFF6D2",
                  color: "#0C1215",
                  borderBottom: "none",
                  borderLeft: "none",
                  borderColor: "#FFF",
                }}
              >
                {formatRate(data.carat24)}
              </td>
              <td style={{ backgroundColor: "#E1BF69", color: "#0C1215", borderBottom: "none", borderColor: "#FFF" }}>
                {formatRate(data.carat22)}
              </td>
              <td style={{ backgroundColor: "#FFF6D2", color: "#0C1215", borderBottom: "none", borderColor: "#FFF" }}>
                {formatRate(data.carat18)}
              </td>
              <td
                style={{
                  backgroundColor: "#E1BF69",
                  color: "#0C1215",
                  borderBottom: "none",
                  borderColor: "#FFF",
                  borderRight: "none",
                }}
              >
                {formatRate(data.carat14)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div styleName="bottom-section-details-wrapper">
        <a href={CTA} target="_blank" rel="noopener noreferrer">
          <span>Click here to view the OGold rates</span>
        </a>
        <span>Powered by OGold</span>
      </div>
    </div>
  );
};

export default OGoldTable;
